import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=1cd5a233&scoped=true&lang=html&"
import script from "./Manage.vue?vue&type=script&lang=js&"
export * from "./Manage.vue?vue&type=script&lang=js&"
import style0 from "./Manage.vue?vue&type=style&index=0&id=1cd5a233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5a233",
  null
  
)

component.options.__file = "Manage.vue"
export default component.exports